// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"80fdec4b","171":"d61e486d","429":"27911449","456":"7d4dbe78","507":"2988652e","923":"9ae36e5b"}[chunkId] + ".chunk.js";
};